const ID_TOKEN_KEY = 'odl.auth.token.id';
const ACCESS_TOKEN_KEY = 'odl.auth.token.access';
const REFRESH_TOKEN_KEY = 'odl.auth.token.refresh';
const STATE_KEY = 'odl.auth.state';
const USER_KEY = 'odl.auth.user';
const LEGACY_AUTH_KEY = 'odl.auth.legacy';
const POOL_KEY = 'odl.auth.cognito.pool';
const REMEMBER_KEY = 'odl.auth.remember';
const IMPERSONATE_USER_KEY = 'odl.auth.impersonate.user';
const IMPERSONATE_ENABLE_KEY = 'odl.auth.impersonate.enable';
const IMPERSONATE_TOKEN_KEY = 'odl.auth.impersonate.token';
const AUTH_METHOD_KEY = 'odl.auth.method';

const STORAGE_KEYS = [
  ID_TOKEN_KEY,
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  STATE_KEY,
  USER_KEY,
  LEGACY_AUTH_KEY,
  POOL_KEY,
  IMPERSONATE_USER_KEY,
  IMPERSONATE_ENABLE_KEY,
  IMPERSONATE_TOKEN_KEY,
  AUTH_METHOD_KEY,
];

class TokenService {
  initialize() {
    STORAGE_KEYS.forEach(key => {
      if (localStorage.getItem(key) == 'undefined') {
        localStorage.removeItem(key);
      }
    });
  }

  clearAll() {
    this.idToken = null;
    this.accessToken = null;
    this.refreshToken = null;
    this.stopImpersonating();
    this.isLegacyAuth = null;
    this.authMethod = null;
    if (!this.rememberMe) {
      this.rememberMe = null;
      this.user = null;
    }
  }

  clearTokens() {
    this.idToken = null;
    this.accessToken = null;
    this.refreshToken = null;
    this.stopImpersonating();
  }

  stopImpersonating() {
    this.impersonationToken = null;
    this.impersonatedUser = null;
    this.isImpersonating = null;
  }

  logout() {
    this.clearAll();
    // Drop the persisted last-route so user A's deep path doesn't
    // get restored into user B's session on the same device.
    try {
      window.localStorage.removeItem('odl.lastRoute');
    } catch {
      // ignore
    }
    window.location.href = '/login';
  }

  parseTokens(payload) {
    this.idToken = payload.id_token;
    this.accessToken = payload.access_token;
    this.refreshToken = payload.refresh_token;
  }

  get state() {
    return localStorage.getItem(STATE_KEY);
  }

  set state(value) {
    if (value == null) {
      localStorage.removeItem(STATE_KEY);
    } else {
      localStorage.setItem(STATE_KEY, value);
    }
  }

  get isLegacyAuth() {
    return localStorage.getItem(LEGACY_AUTH_KEY) === 'true';
  }

  set isLegacyAuth(value) {
    if (value == null) {
      localStorage.removeItem(LEGACY_AUTH_KEY);
    } else {
      localStorage.setItem(LEGACY_AUTH_KEY, JSON.stringify(value));
    }
  }

  get rememberMe() {
    return localStorage.getItem(REMEMBER_KEY) === 'true';
  }

  set rememberMe(value) {
    if (value == null) {
      localStorage.removeItem(REMEMBER_KEY);
    } else {
      localStorage.setItem(REMEMBER_KEY, JSON.stringify(value));
    }
  }

  get pool() {
    return localStorage.getItem(POOL_KEY);
  }

  set pool(value) {
    if (value == null) {
      localStorage.removeItem(POOL_KEY);
    } else {
      localStorage.setItem(POOL_KEY, value);
    }
  }

  get user() {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY));
    } catch (e) {
      this.user = null;
      return null;
    }
  }

  set user(userObject) {
    if (!userObject) {
      localStorage.removeItem(USER_KEY);
    } else {
      localStorage.setItem(USER_KEY, JSON.stringify(userObject));
    }
  }

  get impersonatedUser() {
    try {
      return JSON.parse(localStorage.getItem(IMPERSONATE_USER_KEY));
    } catch (e) {
      this.user = null;
      return null;
    }
  }

  set impersonatedUser(userObject) {
    if (!userObject) {
      localStorage.removeItem(IMPERSONATE_USER_KEY);
    } else {
      localStorage.setItem(IMPERSONATE_USER_KEY, JSON.stringify(userObject));
    }
  }

  get isImpersonating() {
    return localStorage.getItem(IMPERSONATE_ENABLE_KEY) === 'true';
  }

  set isImpersonating(value) {
    if (value == null) {
      localStorage.removeItem(IMPERSONATE_ENABLE_KEY);
    } else {
      localStorage.setItem(IMPERSONATE_ENABLE_KEY, JSON.stringify(value));
    }
  }

  get idToken() {
    return localStorage.getItem(ID_TOKEN_KEY);
  }

  set idToken(value) {
    if (value == null) {
      localStorage.removeItem(ID_TOKEN_KEY);
    } else {
      localStorage.setItem(ID_TOKEN_KEY, value);
    }
  }

  get impersonationToken() {
    return localStorage.getItem(IMPERSONATE_TOKEN_KEY);
  }

  set impersonationToken(value) {
    if (value == null) {
      localStorage.removeItem(IMPERSONATE_TOKEN_KEY);
    } else {
      localStorage.setItem(IMPERSONATE_TOKEN_KEY, value);
    }
  }

  get accessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  set accessToken(value) {
    if (value == null) {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    } else {
      localStorage.setItem(ACCESS_TOKEN_KEY, value);
    }
  }

  get authMethod() {
    return localStorage.getItem(AUTH_METHOD_KEY);
  }

  set authMethod(value) {
    if (value == null) {
      localStorage.removeItem(AUTH_METHOD_KEY);
    } else {
      localStorage.setItem(AUTH_METHOD_KEY, value);
    }
  }

  get refreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  set refreshToken(value) {
    if (value == null) {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    } else {
      localStorage.setItem(REFRESH_TOKEN_KEY, value);
    }
  }
}

const tokenService = new TokenService();

export default tokenService;
